import { useEffect, useState } from 'react';

const useIsSidebarOpen = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('sidebar-open');
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sidebar-open')) {
      urlParams.delete('sidebar-open');
      const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}${window.location.hash}`;
      window.history.replaceState(null, '', newUrl);
    }
  }, []);

  return { isSidebarOpen, setIsSidebarOpen };
};

export default useIsSidebarOpen;
